import React from 'react'

import {
    LegendDot,
    LegendItem,
    OccupancyCard,
    OccupancyGrid,
    OccupancyHeader,
    OccupancyHint,
    OccupancyHintIcon,
    OccupancyLabel,
    OccupancyLegend,
    OccupancyPillsGrid,
    OccupancyPlaceholder,
    OccupancyRow,
    OccupancySubtitle,
    OccupancyTitle,
    StatusText,
} from '../../../../components/scharedStyles/style'
import OccupancyStatusPill from './OccupancyStatusPill'

const EditScheduleOccupancy = ({
    showOccupancy,
    form,
    formatScheduleDate,
    selectedTeacherName,
    selectedGroupNames,
    occupancyRows,
    selectedIds,
    groups,
    selectedOccupancy,
}) => {
    if (!showOccupancy) {
        return (
            <OccupancyPlaceholder>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8v8M8 12h8" />
                </svg>
                <div>
                    <strong>Для просмотра совместной занятости</strong>
                    <p>выберите дату, преподавателя, группу и кабинет</p>
                </div>
            </OccupancyPlaceholder>
        )
    }

    return (
        <OccupancyCard>
            <OccupancyHeader>
                <OccupancyTitle>Совместная занятость на выбранный день</OccupancyTitle>
                <OccupancySubtitle>
                    {form.class_date
                        ? `${formatScheduleDate(form.class_date)} · ${selectedTeacherName} · ${selectedGroupNames}`
                        : 'Выберите дату, преподавателя и группу, чтобы увидеть доступность'}
                </OccupancySubtitle>
            </OccupancyHeader>

            <OccupancyGrid>
                {occupancyRows.length > 0 ? (
                    occupancyRows.map((row, index) => {
                        const isActive = String(row.bellId) === String(form.bell_id)
                        const isConflict = row.combinedBusy

                        return (
                            <OccupancyRow
                                key={`${row.bellId}-${index}`}
                                $active={isActive}
                                $busy={isConflict}
                            >
                                <OccupancyLabel>{`${row.bellNumber} пара`}</OccupancyLabel>

                                <OccupancyPillsGrid>
                                    <OccupancyStatusPill title="Преподаватель" busy={row.teacherBusy} />

                                    {selectedIds.length > 0 ? (
                                        selectedIds.map((groupId) => {
                                            const groupStatus = row.groups?.find(
                                                (g) => String(g.id) === String(groupId)
                                            )?.isBusy ?? false

                                            const groupName = groups.find(
                                                (g) => String(g.group_id) === String(groupId)
                                            )?.name || groupId

                                            return (
                                                <OccupancyStatusPill
                                                    key={groupId}
                                                    title={groupName}
                                                    busy={groupStatus}
                                                />
                                            )
                                        })
                                    ) : (
                                        <span style={{ color: '#999', fontSize: '12px' }}>
                                            Группа не выбрана
                                        </span>
                                    )}

                                    <OccupancyStatusPill title="Кабинет" busy={row.roomBusy} />
                                </OccupancyPillsGrid>
                            </OccupancyRow>
                        )
                    })
                ) : (
                    <StatusText>Нет данных по занятости</StatusText>
                )}
            </OccupancyGrid>

            <OccupancyLegend>
                <LegendItem>
                    <LegendDot />
                    <span>Свободно</span>
                </LegendItem>
                <LegendItem>
                    <LegendDot $busy />
                    <span>Занято</span>
                </LegendItem>
            </OccupancyLegend>

            <OccupancyHint $busy={selectedOccupancy?.combinedBusy}>
                {selectedOccupancy ? (
                    selectedOccupancy.combinedBusy ? (
                        <>
                            <OccupancyHintIcon>✗</OccupancyHintIcon>
                            <span>
                                На выбранной паре есть конфликт по преподавателю,
                                группе или кабинету
                            </span>
                        </>
                    ) : (
                        <>
                            <OccupancyHintIcon>✓</OccupancyHintIcon>
                            <span>
                                Преподаватель, выбранные группы и кабинет свободны
                                на выбранной паре
                            </span>
                        </>
                    )
                ) : (
                    <span>
                        Выберите пару, чтобы проверить конкретную совместную занятость
                    </span>
                )}
            </OccupancyHint>
        </OccupancyCard>
    )
}

export default EditScheduleOccupancy
